import React from 'react';
import '../styles/Privacy-Policy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">

        <h1>Privacy Policy</h1>

        <p className="effective-date">
          Effective Date: January 1, 2026
        </p>

        <p className="intro-text">
          Mosaic Digital Creations ("we," "our," or "us") values your privacy
          and is committed to protecting any information you provide through
          our website.
        </p>

        <section>
          <h2>Information We Collect</h2>

          <p>
            We may collect personal information that you voluntarily provide
            when you:
          </p>

          <ul>
            <li>Submit a contact form</li>
            <li>Request information about our services</li>
            <li>Communicate with us by email</li>
            <li>Subscribe to updates or newsletters (if applicable)</li>
          </ul>

          <p>
            This information may include:
          </p>

          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name</li>
            <li>Project details or inquiries</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>

          <p>
            We use the information collected to:
          </p>

          <ul>
            <li>Respond to inquiries</li>
            <li>Provide requested services</li>
            <li>Improve our website and customer experience</li>
            <li>Communicate regarding projects or support requests</li>
            <li>Maintain website functionality and security</li>
          </ul>

          <p>
            We do not sell or rent your personal information to third parties.
          </p>
        </section>

        <section>
          <h2>Cookies & Analytics</h2>

          <p>
            Our website may use cookies or analytics tools to better understand
            website traffic and user interactions. These tools help us improve
            website performance and user experience.
          </p>

          <p>
            You may disable cookies through your browser settings at any time.
          </p>
        </section>

        <section>
          <h2>Third-Party Services</h2>

          <p>
            We may use trusted third-party services for:
          </p>

          <ul>
            <li>Website hosting</li>
            <li>Email communication</li>
            <li>Analytics</li>
            <li>Form processing</li>
          </ul>

          <p>
            These providers may have access to limited information necessary
            to perform their services securely.
          </p>
        </section>

        <section>
          <h2>Data Protection</h2>

          <p>
            We take reasonable measures to protect your information from
            unauthorized access, misuse, or disclosure.
          </p>

          <p>
            However, no method of internet transmission or electronic storage
            is completely secure.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>

          <p>
            You may request to:
          </p>

          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
          </ul>

          <p>
            To make a request, please contact us using the information below.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>

          <p>
            We may update this Privacy Policy periodically. Any updates will
            be posted on this page with a revised effective date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>

          <p>
            If you have questions regarding this Privacy Policy, you may
            contact us at:
          </p>

          <div className="contact-box">
            <p><strong>Mosaic Digital Creations</strong></p>
            <p>Email: info@mosaicdigitalcreations.com</p>
            <p>Website: https://www.mosaicdigitalcreations.com</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;